export default {
	themes: {
		light: 'Chiaro',
		dark: 'Scuro'
	}
};
